import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	dispatches: [],
};

const packsSlice = createSlice({
	name: 'packOrders',
	initialState: initialState,
	reducers: {
		setPackOrders: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setPackOrders, reset } = packsSlice.actions;

export default packsSlice.reducer;